<template>    
  <el-dialog 
    width="420px"
    :title="dialog.title" 
    :visible.sync="dialog.isShow"
    @open='open' >
    <el-form ref="form" :model="form" label-width="80px" size="medium"> 
      <el-form-item label="名称">
        <el-input v-model="form.title"></el-input>            
      </el-form-item>
      <el-form-item label="总金额">
        <el-input v-model="form.totalAmount"></el-input>            
      </el-form-item>
      <el-form-item label="总数量">
        <el-input v-model="form.totalCount"></el-input>            
      </el-form-item>
      <el-form-item label="开抢时间">    
        <el-date-picker
          v-model="form.openTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialog.isShow = false">取 消</el-button>
      <el-button type="primary" @click="Save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script  type='text/ecmascript-6'>
export default {
  props:{
    dialog:{}
  },
  data (){
    return {
      form : {},
      parentIndustry:[],
    }
  },  
  components:{
  },
  computed:{
  },
  mounted(){
  },
  methods:{   
    open:function(){
      var that = this
      this.axios({
        method:'Get',
        url:that.global.serverSrc + '/api/RedEnvelope/Get',         
        params:{
          id: that.dialog.id
        }
      }).then(function (resp) {
        if(resp.data.errorCode==0){
          that.form = resp.data.redEnvelope
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    },
    Save(){
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/RedEnvelope/Save',         
        data:this.form
      }).then(function (resp) {
        if(resp.data.errorCode==0){
          that.$message.success(resp.data.message);
          that.dialog.isShow = false
          that.$emit('GetData')
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    }, 
  },
  created(){
  
  },
}
</script>